const calculateAxis = (item, valueKeys) => {

    const independentAxisKey = valueKeys.findIndex(obj => obj.responseKey === item);
    const { independentAxis } = valueKeys[independentAxisKey] || {}
    const asixId = independentAxis === true ? "right" : "left";
    console.log(asixId, item);
    return asixId
};

const rightAxisVisible = ({ valueKeys = [] }) => {
    // Check if any valueKey has independentAxis set to true
    return valueKeys.some(key => key.independentAxis === true);
};


export { calculateAxis, rightAxisVisible };